import NodeWrapper from './NodeWrapper';
import ContactTopic from './ContactTopic';
import ContactResult from './ContactResult';
import SDXContactWizard from './Tc.Module.SDXContactWizard';

export default class ContactStep extends NodeWrapper {
	private nextStep! : ContactStep;
	private previousStep! : ContactStep;
	private module : SDXContactWizard;
	private topicsByName : Map<string, NodeWrapper>;
	private selectedTopic! : ContactTopic;
	private topics : ContactTopic[];
	private results : ContactResult[];

	constructor(
		$ctx : JQuery,
		module : SDXContactWizard,
		previousStep? : ContactStep,
	) {
		super($ctx);
		this.module = module;
		this.topicsByName = new Map();
		this.topics = [];
		this.results = [];
		if (previousStep) {
			this.previousStep = previousStep;
			previousStep.nextStep = this;
		}

		this.$ctx.find('.step-back > button').on('click', this.deselect.bind(this));
	}

	public namedTopic(topicName : string) {
			return this.topicsByName.get(topicName);
	}

	get getPreviousStep() : ContactStep {
		return this.previousStep;
	}

	get getNextStep() : ContactStep {
		return this.nextStep;
	}

	public addTopic(topic : ContactTopic) {
		this.topics.push(topic);
		this.topicsByName.set(topic.topicName, topic);
		topic.step = this;
	}

	public addResult(result : ContactResult) {
		this.results.push(result);
		result.step = this;
	}

	public updateItems(current : boolean | null, active : boolean | null) {
		this.topics.forEach(topic => topic.updateState(current, active));
		this.results.forEach(result => result.updateState(current, active));
	}

	public getTopics() {
		return this.topics;
	}

	public deselect() {
		if (!this.selectedTopic) {
			return;
		}

		const newTopic = (this.previousStep && this.previousStep.selectedTopic) || null;
		this.selectTopic(newTopic);
	}

	public markActive(parentTopic : ContactTopic) {
		let activeItems : NodeWrapper[] = [];
		if (parentTopic) {
			// Mark which subset of topics/results are active (the ones whose parent are from the previous step)
			activeItems = parentTopic.getChildren();
		}

		// Deactivate all items
		this.updateItems(false, false);

		// Activate active items
		activeItems.forEach(topic => topic.updateState(null, true));

		// Set step active if we have topics to show in this step
		this.updateState(null, !!activeItems.length);
	}


	public selectTopic(topic : ContactTopic) {
		// Search parents of the newly-selected topic until we found one in our step (like jQuery.fn.closest)
		let stepTopic = topic;

		while (stepTopic && stepTopic.step !== this) {
			stepTopic = stepTopic.parent as ContactTopic;
		}

		// Mark the step topic as selected
		this.selectedTopic = stepTopic;

		this.setAdditionalClasses();

		if (this.selectedTopic) {
			const children = this.selectedTopic.getChildren();
			const $par = children.length ? children[0].getContext().parent() : $();
			if (this.selectedTopic.isResult) {
				$par.siblings('.additional-info').addClass('hidden');
			} else {
				$par.siblings('.additional-info').removeClass('hidden');
			}
		}

		// Set current if we have a “current” topic for this step
		this.updateState(!!stepTopic, null);

		// Remove “current” from all items
		this.updateItems(false, null);
		// Mark current item active (if any)
		if (stepTopic) {
			stepTopic.updateState(true, null);
		}

		// Propagate to the next step (if any)
		if (this.nextStep) {
			if (this.selectedTopic && this.selectedTopic.isResult && this.nextStep.nextStep) {
				this.nextStep.updateState(null, false);
				this.nextStep.nextStep.markActive(stepTopic);
				this.nextStep.nextStep.selectTopic(topic);
			} else {
				this.nextStep.markActive(stepTopic);
				this.nextStep.selectTopic(topic);
			}
		} else {
			// Mark topic as selected in the module (for hash handling, scrolling and stuff)
			this.module.topicSelected(topic);
		}
	}

	public setAdditionalClasses() {
		this.$ctx.toggleClass('link-selected', !!(this.selectedTopic && this.selectedTopic.isLink()));
		if (this.selectedTopic &&
				this.nextStep &&
				this.nextStep.nextStep &&
				this.selectedTopic.isResult) {
			// Explicitely call set additional classes since in this case this step will be skipped by selectTopic()
			this.nextStep.setAdditionalClasses();
		}
		if(!this.selectedTopic &&
				this.previousStep &&
				this.previousStep.selectedTopic &&
				this.previousStep.selectedTopic.isResult) {
			this.$ctx.addClass('skipped');
		} else {
			this.$ctx.removeClass('skipped');
		}
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/contact/ContactStep.ts